import React, { useState } from "react";
import type { ServiceProductConflictModalType } from "../../../utils/modalConstants";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { resolveServiceProductConflict } from "../../../redux/actions/BasketActions";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as InputStyles from "../../../../../../common-deprecated/styles/toyota/Input";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const ServiceProductConflictModal = (props: ModalViewType<ServiceProductConflictModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { serviceProduct, conflicts } = modalSettings;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const hasConflicts = !!(conflicts && conflicts.length > 0);

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="serviceProductConflictTitle" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                {hasConflicts && (
                    <Flex.Row>
                        <Flex.Col display="flex" flexDirection="column">
                            {conflicts.map((item) => (
                                <InputStyles.Wrapper key={item.id} mb={2}>
                                    <input
                                        id={`${item.id}-conflict`}
                                        type="checkbox"
                                        checked={selectedId === item.id}
                                        name="conflicts"
                                        onChange={() => {
                                            if (!selectedId || selectedId !== item.id) setSelectedId(item.id);
                                            else setSelectedId(null);
                                        }}
                                    />
                                    <InputStyles.Checkbox htmlFor={`${item.id}-conflict`}>
                                        {item.name}
                                    </InputStyles.Checkbox>
                                </InputStyles.Wrapper>
                            ))}
                        </Flex.Col>
                    </Flex.Row>
                )}
            </Modal.Body>
            <Modal.Actions>
                <Flex.Col p={0} display="flex" justifyContent="flex-end">
                    <Button.Primary
                        m={0}
                        disabled={!selectedId}
                        onClick={() => {
                            if (hasConflicts) {
                                const selectedItem = conflicts.find(
                                    (serviceProductConflict) => selectedId === serviceProductConflict.id,
                                );
                                if (selectedItem) {
                                    dispatch(resolveServiceProductConflict(serviceProduct, selectedItem, conflicts));
                                    close();
                                }
                            }
                        }}
                    >
                        <BnbLabel label="serviceProductConflictContinue" />
                    </Button.Primary>
                </Flex.Col>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ServiceProductConflictModal;
